// extracted by mini-css-extract-plugin
module.exports = {"reportRoot":"top10AiTools_reportRoot__cvH5Q"};